module.exports = __webpack_public_path__ + "assets/img/uesrIcon2.62941256.png";